"use strict";

var _taggedTemplateLiteral = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js").default;
var _toConsumableArray = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _slicedToArray = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _templateObject, _templateObject2;
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var _ownKeys = function ownKeys(o) {
    _ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return _ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = _ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AtomPriceLine = void 0;
var react_1 = __importStar(require("react"));
var d3_1 = require("d3");
var d3fc_discontinuous_scale_1 = require("@d3fc/d3fc-discontinuous-scale");
var styled_components_1 = __importDefault(require("styled-components"));
var AtomAxis_1 = __importDefault(require("../common/AtomAxis"));
var luxon_1 = require("luxon");
var hooks_1 = require("../helpers/hooks");
var AtomCrosshair_1 = __importDefault(require("../common/AtomCrosshair"));
var AtomSVGTooltip_1 = __importDefault(require("../common/AtomSVGTooltip"));
var AtomPriceLine = function AtomPriceLine(_ref) {
  var data = _ref.data,
    xScale = _ref.xScale,
    yScale = _ref.yScale;
  var lineGen = (0, d3_1.line)().defined(function (d) {
    return d.Close !== null;
  }).x(function (d) {
    return xScale(new Date(d.DT));
  }).y(function (d) {
    return yScale(d.Close);
  }).curve(d3_1.curveMonotoneX);
  var path = lineGen(data);
  if (!path) return null;
  return react_1.default.createElement("path", {
    className: 'price-line',
    d: path
  });
};
exports.AtomPriceLine = AtomPriceLine;
var AtomPriceLineChart = function AtomPriceLineChart(_ref2) {
  var _ref2$resize = _ref2.resize,
    resize = _ref2$resize === void 0 ? 1 : _ref2$resize,
    data = _ref2.data,
    margin = _ref2.margin,
    axisDateFormat = _ref2.axisDateFormat,
    tooltipDateFormat = _ref2.tooltipDateFormat,
    _ref2$crosshair = _ref2.crosshair,
    crosshair = _ref2$crosshair === void 0 ? false : _ref2$crosshair,
    dateDomain = _ref2.dateDomain;
  var _ref3 = (0, react_1.useState)(undefined),
    _ref4 = _slicedToArray(_ref3, 2),
    hover = _ref4[0],
    setHover = _ref4[1];
  var _ref5 = (0, hooks_1.useSVGSize)(),
    _ref6 = _slicedToArray(_ref5, 2),
    svgRef = _ref6[0],
    _ref6$ = _ref6[1],
    width = _ref6$.width,
    height = _ref6$.height;
  var marginObj;
  if (margin === undefined) {
    var generatedMargin = width * 0.05;
    marginObj = {
      top: generatedMargin,
      right: generatedMargin,
      bottom: generatedMargin,
      left: generatedMargin
    };
  } else if (typeof margin === 'number') marginObj = {
    top: margin,
    right: margin,
    bottom: margin,
    left: margin
  };else marginObj = margin;
  var closeData = data.map(function (d) {
    return d.Close;
  }).filter(function (d) {
    return d;
  });
  var yScale = (0, d3_1.scaleLinear)().domain([Math.min.apply(Math, _toConsumableArray(closeData)), Math.max.apply(Math, _toConsumableArray(closeData))]).range([height - marginObj.bottom, marginObj.top]).nice();
  var dateData = data.map(function (d) {
    return d.DT;
  });
  var discontinuousScale = (0, d3fc_discontinuous_scale_1.scaleDiscontinuous)((0, d3_1.scaleTime)()).discontinuityProvider((0, d3fc_discontinuous_scale_1.discontinuitySkipWeekends)()).domain(dateDomain // discontinuity scale requires JS dates for the domain and will break on DateTime
  ? dateDomain.map(function (d) {
    return new luxon_1.DateTime(d).toJSDate();
  }) : [new Date(Math.min.apply(Math, _toConsumableArray(dateData))), new Date(Math.max.apply(Math, _toConsumableArray(dateData)))]).range([marginObj.left, width - marginObj.right]);
  var getQuadrant = (0, react_1.useCallback)(function (x, y) {
    if (x > width / 2 && y < height / 2) return 1;
    if (x < width / 2 && y < height / 2) return 2;
    if (x < width / 2 && y > height / 2) return 3;
    if (x > width / 2 && y > height / 2) return 4;else return 1;
  }, [width, height]);
  var numTicks = 4;
  var priceFormat = (0, react_1.useCallback)(function () {
    var _yScale$domain = yScale.domain(),
      _yScale$domain2 = _slicedToArray(_yScale$domain, 2),
      start = _yScale$domain2[0],
      stop = _yScale$domain2[1];
    var step = (0, d3_1.tickStep)(start, stop, numTicks);
    if (step < 1) return (0, d3_1.format)('$.2f');else return (0, d3_1.format)('$.0f');
  }, [yScale]);
  var onMouseMove = (0, react_1.useCallback)(function (e) {
    var _ref7 = (0, d3_1.pointer)(e),
      _ref8 = _slicedToArray(_ref7, 1),
      x = _ref8[0];
    var ms = luxon_1.DateTime.fromJSDate(discontinuousScale.invert(x)).toMillis();
    var index = (0, d3_1.bisect)(dateData, ms);
    var thisData = data[index];
    if (thisData) setHover(Object.assign({
      x: discontinuousScale(new Date(thisData.DT)),
      y: yScale(thisData.Close)
    }, thisData));
  }, [dateData, data, discontinuousScale, yScale]);
  // Discontinuous scale includes more than one tick for the weekends.
  // This removes duplicate ticks in the instance that the domain includes a weekend
  var discontinousTicks = Array.from(new Set(discontinuousScale.ticks(numTicks).map(function (d) {
    return luxon_1.DateTime.fromJSDate(d).toMillis();
  }))).map(function (ms) {
    return new Date(ms);
  });
  return react_1.default.createElement(StyledSVG, {
    ref: svgRef,
    onMouseMove: onMouseMove,
    onPointerMove: onMouseMove,
    onMouseLeave: function onMouseLeave() {
      return setHover(undefined);
    }
  }, resize &&
  // see note about resize above
  data && data.length &&
  // only make visuals when there is data
  width > 0 && height > 0 &&
  // only render if there is svg space
  react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(exports.AtomPriceLine, {
    data: data,
    xScale: discontinuousScale,
    yScale: yScale
  }), react_1.default.createElement(AtomAxis_1.default, {
    ticks: discontinousTicks,
    scale: discontinuousScale,
    orientation: 'bottom',
    offset: [0, height - marginObj.bottom],
    format: axisDateFormat
  }), react_1.default.createElement(AtomAxis_1.default, {
    ticks: yScale.ticks(numTicks),
    scale: yScale,
    orientation: 'right',
    tickLength: width - (marginObj.left + marginObj.right),
    offset: [width - marginObj.right, 0],
    format: priceFormat()
  }), crosshair && hover && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(AtomCrosshair_1.default, {
    x: hover.x,
    xVal: tooltipDateFormat(hover.DT),
    y: hover.y,
    yVal: priceFormat()(hover.Close),
    marginObj: marginObj,
    width: width,
    height: height
  }), react_1.default.createElement(AtomSVGTooltip_1.default, {
    x: hover.x,
    y: hover.y,
    quadrant: getQuadrant(hover.x, hover.y),
    innerHTML: react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(StyledRow, null, react_1.default.createElement("strong", null, "Date/Time:"), ' ', tooltipDateFormat(luxon_1.DateTime.fromMillis(hover.DT))), react_1.default.createElement(StyledRow, null, react_1.default.createElement("strong", null, "Price:"), " ", (0, d3_1.format)('$.2f')(hover.Close)))
  }))));
};
var StyledSVG = styled_components_1.default.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n\n  * {\n    pointer-events: none;\n  }\n"])));
var StyledRow = styled_components_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: var(--text-primary);\n  font-size: 0.75em;\n"])));
exports.default = AtomPriceLineChart;